import { useParams } from "react-router-dom";
import AdAgreement from "./AdAgreement";
import PersonalData from "./PersonalData";
import NotFound from "@NotFound";

const Documents = () => {
    const { secondParam } = useParams();

    const Specified = secondParam && docs[secondParam] ? docs[secondParam] : NotFound;

    return <Specified />;
};

export default Documents;

const docs = {
    "ad-agreement": AdAgreement,
    "personal-data": PersonalData,
};
